import cx from 'classnames';
import styles from './IsolatedScriptFrame.module.scss';

// Site tokens the frame uses. CSS variables don't cross into the frame, so their values are read from the page when the frame is built.
// Size tokens are left out: they are rem on the site's 10px root and would be wrong on the frame's 16px root
export const FRAME_TOKENS = [
	'--font-primary',
	'--font-weight--normal',
	'--font-weight--medium',
	'--website-color-text--primary',
	'--website-color-text--subtle',
];

// Sizes match body--md (16px/24px); colors and weights follow FRAME_TOKENS
export const FRAME_BASE_CSS = `
html{font-size:16px;}
body{margin:0;display:flow-root;font-family:var(--font-primary,sans-serif);font-size:16px;line-height:24px;font-weight:var(--font-weight--normal);color:var(--website-color-text--primary);-webkit-font-smoothing:antialiased;}
a{color:var(--website-color-text--subtle);text-decoration:underline;}
h1,h2,h3,h4,h5,h6{font-weight:var(--font-weight--medium);line-height:1.25;}
img{max-width:100%;height:auto;}
table{border-collapse:collapse;max-width:100%;}
th,td{text-align:left;vertical-align:top;padding:8px;}
`;

export interface IsolatedScriptFrameProps {
	srcDoc: string;
	title: string;
	sandbox: string;
	height: number;
	frameRef?: React.Ref<HTMLIFrameElement>;
	className?: string;
}

export const IsolatedScriptFrame: React.FC<IsolatedScriptFrameProps> = ({ srcDoc, title, sandbox, height, frameRef, className }) => {
	const hasContent = height > 0;

	return (
		<div className={cx(styles.IsolatedScriptFrame, { [styles.IsolatedScriptFrame___hasContent]: hasContent }, className)}>
			<iframe
				ref={frameRef}
				className={styles.IsolatedScriptFrame_frame}
				title={title}
				sandbox={sandbox}
				srcDoc={srcDoc}
				style={{ height }}
				aria-hidden={!hasContent || undefined}
				tabIndex={hasContent ? undefined : -1}
			/>
		</div>
	);
};
